import React, { Component } from "react";
import ChurchMembersTable from "./churchMembersTable";

export default class ChurchMembers extends Component {
  render() {
    return (
      <div>
        <div className="dashboard-layout__placeholder"/>
        <div className="m-24">
          <h2 style={{marginBottom: 10}}>Church Members</h2>
          <ChurchMembersTable {...this.props}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/churchMembers/churchMembers.js